module.exports = require("./../../_gen/starling/rendering/Program");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/Program.js
// module id = 216
// module chunks = 0